"use strict";

define('app/study/detail/document.detail.view',['vertebrae', 'select2'], function (Vertebrae) {
  var DocumentDetailView = Vertebrae.View.extend({
    templates: {
      'document.detail': 'renderInitFragment'
    },
    events: {
      'change [data-action="assignAnalyst"]': 'handleChangeAnalyst',
      'click .document-meeting': 'handleDocumentMeetingClick',
      'click .document-task-action-btn': 'handleDocumentTaskAnswer',
      'click .document-decision': 'handleDocumentDecisionClick',
      'click .child-decision': 'handleDocumentDecisionClick',
      'click .document-sent-letter': 'handleDocumentLetterClick',
      'click .document-action-btn': 'handleDocumentAction',
      'tab-change .tab': 'handleTabChange',
      'click .promote-decision-btn': 'handlePromoteDecisionClick',
      'click .child-decision.selectable': 'handleChildDecisionClick'
    },
    tab: 'details',
    hide: function hide() {
      this.$el.hide();
    },
    show: function show() {
      this.$el.show();
    },
    render: function render(data) {
      this.$el.html(this.renderInitFragment(data));
      this.setupAnalystFinder();
      this.$('[data-tab="' + this.tab + '"]').trigger('init-tab');
    },
    handleTabChange: function handleTabChange(ev) {
      var el = $(ev.currentTarget),
        tab = el.data('tab');
      this.showTab(tab);
    },
    resetTab: function resetTab() {
      this.tab = 'details';
      return this;
    },
    showTab: function showTab(tab) {
      var tabContents = this.$('.tab-content').hide().filter('[data-tab="' + tab + '"]').show();
      this.tab = tab;
      this.trigger('change:tab');
    },
    setupAnalystFinder: function setupAnalystFinder() {
      console.warn("Select2 analysts dropdown may be initialized incorrectly!");
      var delegate = this.getDelegate(),
        documentService = delegate.getDocumentService(),
        workflowService = documentService.getWorkflowService(),
        currentAnalyst = documentService.getCurrentAnalyst(),
        analysts = delegate.getStudyService().getAnalysts().data.map(function (analyst) {
          return {
            id: analyst.id,
            text: [analyst.firstName, " ", analyst.lastName].join('')
          };
        }),
        format = null;
      format = function format(item) {
        return item.text;
      };
      this.$el.find('[data-action="assignAnalyst"]').select2({
        minimumResultsForSearch: Infinity,
        width: '50%',
        data: analysts,
        templateSelection: function templateSelection() {
          return currentAnalyst ? 'CHANGE ANALYST' : 'ASSIGN ANALYST';
        },
        templateResult: format,
        placeholder: 'Assign Analyst'
      }).val(_.result(currentAnalyst, 'id').trigger('change'));
    },
    getElementData: function getElementData(el, field) {
      return $(el).data(field || 'id');
    },
    handleDocumentTaskAnswer: function handleDocumentTaskAnswer(ev) {
      var value = this.getElementData(ev.currentTarget, 'value');
      this.getDelegate().requestApplyWorkflowAnswer(value);
    },
    handleDocumentMeetingClick: function handleDocumentMeetingClick(ev) {
      this.getDelegate().requestMeetingById(this.getElementData(ev.currentTarget));
    },
    handleDocumentDecisionClick: function handleDocumentDecisionClick(ev) {
      this.getDelegate().requestDocumentDecisionById(this.getElementData(ev.currentTarget));
    },
    handleDocumentLetterClick: function handleDocumentLetterClick(ev) {
      this.getDelegate().requestDocumentLetterById(this.getElementData(ev.currentTarget));
    },
    handleChangeAnalyst: function handleChangeAnalyst(ev) {
      this.getDelegate().requestAssignAnalyst(ev.added);
    },
    handleDocumentAction: function handleDocumentAction(ev) {
      var action = this.getElementData(ev.currentTarget, 'action');
      this.getDelegate().requestDocumentActivity(action);
    },
    handleChildDecisionClick: function handleChildDecisionClick(ev) {
      var decision = $(ev.currentTarget),
        decisions = decision.siblings('.child-decision');
      decisions.removeClass('active');
      decision.toggleClass('active');
    },
    handlePromoteDecisionClick: function handlePromoteDecisionClick(ev) {
      var decisionEl = $(ev.currentTarget).closest('.child-decision'),
        decisionId = decisionEl.data('id');
      ev.stopPropagation();
      this.getDelegate().requestPromoteDecision(decisionId);
    }
  });
  return DocumentDetailView;
});

